import React, { useEffect, useState } from "react";
import NewNavBar from "../../components/NewNavBar/NewNavBar";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import CustomSpinner from "../../components/CustomeSpinner/CustomeSpinner";
import Footer from "../../components/Footer/Footer";
import { Backdrop } from "@mui/material";
import { Star } from '@mui/icons-material';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
    const [isLoading, setIsLoading] = useState(false);
    useEffect(()=>{
        window.scrollTo(0,0);
    },[])
    const policies = [
        {
            id: 1,
            title: "Introduction",
            subPolicies: [
                "Last updated: January 20th, 2016",
                "This privacy policy is for www.GhoomoWorld.com and served by Ghoomo World Tours and Travels Pvt. Ltd. and governs the privacy of its users who choose to use it.",
                "The policy sets out the different areas where user privacy is concerned and outlines the obligations & requirements of the users, the website and website owners."
            ],
        },
        {
            id: 2,
            title: "The Website",
            subPolicies: [
                "This website and its owners take a proactive approach to user privacy and ensure the necessary steps are taken to protect the privacy of its users throughout their visiting experience.",
                "This website complies with all India's national laws and requirements for user privacy."
            ],
        },
        {
            id: 3,
            title: "Use of Cookies",
            subPolicies: [
                "This website uses cookies to better the users experience while visiting the website.",
                "This website uses tracking software to monitor its visitors to better understand how they use it. This software is provided by Google Analytics."
            ],
        },
        {
            id: 4,
            title: "Email Newsletter",
            subPolicies: [
                "Users may subscribe to our email newsletter program. Personal details are collected and stored securely until they are no longer required."
            ],
        },
        {
            id: 5,
            title: "External Links",
            subPolicies: [
                "Although this website only looks to include quality, safe and relevant external links, users are advised adopt a policy of caution before clicking any external web links."
            ],
        },
        {
            id: 6,
            title: "Adverts and Sponsored Links",
            subPolicies: [
                "This website may contain sponsored links and adverts served through our advertising partners."
            ],
        },
        {
            id: 7,
            title: "Social Media Platforms",
            subPolicies: [
                "Communication, engagement and actions taken through external social media platforms that this website and its owners participate on are custom to the terms and privacy policies held with each platform."
            ],
        },
        {
            id: 8,
            title: "Shortened Links in Social Media",
            subPolicies: [
                "This website and its owners may share shortened links through their social media accounts. Users should exercise caution before clicking."
            ],
        },
        {
            id: 9,
            title: "Rediscover Paradise Privacy Policy",
            subPolicies: [
                "This Privacy and Cookies Policy describes how ANHEUSER-BUSCH INBEV SA/NV and its Affiliates ('ABI') collect, use, share, and otherwise process personal data.",
            ],
        },
        {
            id: 10,
            title: "Data Collection",
            subPolicies: [
                "Depending on the purpose of the processing, we may process personal details, contact details, idea submissions, geolocation data, cookies/tracking data, etc."
            ],
        },
        {
            id: 11,
            title: "Purposes of Processing",
            subPolicies: [
                "We process your data to provide services, analyze usage, improve user experience, comply with legal obligations, and protect rights."
            ],
        },
        {
            id: 12,
            title: "Data Sharing",
            subPolicies: [
                "ABI may share your personal data with authorized staff, affiliates, service providers, legal authorities, or in corporate transactions."
            ],
        },
        {
            id: 13,
            title: "Data Retention",
            subPolicies: [
                "Personal data is retained only as long as necessary to fulfil purposes described in this policy."
            ],
        },
        {
            id: 14,
            title: "Your Rights",
            subPolicies: [
                "You may have rights including: confirmation, access, rectification, deletion, restriction, portability, objection, withdrawing consent, and lodging complaints with authorities."
            ],
        },
    ];

    return (
        <>
            {isLoading && (
                <Backdrop
                    sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        backdropFilter: "blur(5px)",
                        backgroundColor: "rgba(0, 0, 0, 0.4)",
                    }}
                    open={isLoading}
                >
                    <CustomSpinner color="inherit" />
                </Backdrop>
            )}

            <div className="stickyheader">
                <Header />
                <NewNavBar className="newnavbartoggle" />
            </div>

            <Sidebar className="sidebartoggle" />

            <main className="p-6 md:ml-64 bg-gray-50 min-h-screen">
                <div className="container mb-5">
                    <div className="about-header">
                        <div className="header-content">
                            <div className="header-icon">
                                <Star style={{ fontSize: 48 }} />
                            </div>
                            <div className="header-text">
                                <h1>Privacy Policy</h1>
                                {/* <p className="header-description">
                                    We create joyful travel experiences with research-driven itineraries, reliable service, and all-inclusive value. Get to know the people, processes, and passion behind our journeys.
                                </p> */}
                            </div>
                        </div>
                    </div>
                    {/* <h1 className="text-3xl font-bold mb-6 text-gray-800 mt-2" style={{ color: 'black' }}>
                        Privacy Policy
                    </h1> */}

                    <div className="space-y-4">
                        {policies.map((policy) => (
                            <div
                                key={policy.id}
                                className="bg-white p-4 rounded-2xl shadow hover:shadow-lg transition border border-gray-200 mt-1 mb-2"
                                style={{ borderRadius: '15px' }}
                            >
                                <h5 className="text-xl font-semibold text-indigo-700 mb-1">
                                    {policy.title}
                                </h5>
                                <ul className="list-disc pl-6 text-gray-700 space-y-1">
                                    {policy.subPolicies.map((sub, idx) => (
                                        <li key={idx}>{sub}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </main>

            <Footer />
        </>
    );
};

export default PrivacyPolicy;
